import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ConfigProvider} from "../base/config";
import {map} from "rxjs/operators";

/*
  Generated class for the LocalidadeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocalidadeProvider {


  constructor(public http: HttpClient) {
  }

  listaEstados(params: any = {}, headers: HttpHeaders = null) {
    return this.http.get<any[]>(ConfigProvider.host + '/api/v1/front/localidade/estados/select-estados',{
      params: params,
      headers: headers
    }).pipe(
        map((response: any) => {
          return response;
        })
    );
  }

  listaCidade(estadoId, params: any = {}, headers: HttpHeaders = null) {
    return this.http.get<any[]>(ConfigProvider.host + '/api/v1/front/localidade/cidades/select-cidades/' + estadoId,{
      params: params,
      headers: headers
    }).pipe(
        map((response: any) => {
          return response;
        })
    );
  }

}



// WEBPACK FOOTER //
// ./src/providers/localidade/localidade.ts